import campaignAnalytics from "images/home-v2/screenshots/campaign-analytics.jpg";
import campaignBuilder from "images/home-v2/screenshots/campaign-builder.jpg";
import integrations from "images/home-v2/screenshots/integrations.jpg";
import partnerSweepstakes from "images/home-v2/screenshots/partner-sweepstakes.jpg";

/**
 * @typedef {Object} FeatureShowcaseItem
 * @property {string} key - unique identifier
 * @property {string} eyebrow - short label rendered in the pill above the title
 * @property {"blue" | "coral" | "cobalt" | "teal"} tint - accent color for the eyebrow pill
 * @property {string} title - panel heading
 * @property {string} body - descriptive paragraph
 * @property {string[]} bullets - three short value props shown as checkmark bullets
 * @property {string} imgSrc - imported screenshot URL
 * @property {string} alt - image alt text
 */

/** @type {FeatureShowcaseItem[]} */
export const featureShowcase = [
  {
    key: "partners",
    eyebrow: "Partner network",
    tint: "blue",
    title: "Partner with brands that actually move the needle",
    body: "Browse thousands of vetted brands across e-commerce, media, and lifestyle. Filter by audience size, vertical, and open sweepstakes to land the strongest co-marketing matches.",
    bullets: [
      "Curated network of 5,000+ active brands",
      "Filter by audience size, vertical, and reach",
      "Open-sweepstakes marketplace updated daily",
    ],
    imgSrc: partnerSweepstakes,
    alt: "DojoMojo partner sweepstakes browse view",
  },
  {
    key: "builder",
    eyebrow: "Campaign builder",
    tint: "coral",
    title: "Launch co-branded giveaways in hours, not weeks",
    body: "Drag-and-drop builder with landing page templates, auto-generated Official Rules, and a live preview. Go from blank canvas to live sweepstakes in a single afternoon.",
    bullets: [
      "Drag-and-drop landing page builder",
      "Custom branding, domains, and social actions",
      "Automated Official Rules and compliance",
    ],
    imgSrc: campaignBuilder,
    alt: "DojoMojo campaign overview dashboard",
  },
  {
    key: "analytics",
    eyebrow: "Analytics",
    tint: "cobalt",
    title: "Understand what converts, down to the partner",
    body: "Real-time dashboards show subscriber growth and source attribution across every campaign. Double down on what works, cut what doesn't.",
    bullets: [
      "Real-time campaign analytics",
      "Source attribution per partner and channel",
      "Historical trends and cohort comparisons",
    ],
    imgSrc: campaignAnalytics,
    alt: "DojoMojo campaign analytics dashboard",
  },
  {
    key: "integrations",
    eyebrow: "Integrations",
    tint: "teal",
    title: "Plug into the tools your team already lives in",
    body: "Native sync with Klaviyo, Mailchimp, HubSpot, and 20+ other email platforms. New subscribers flow straight into your nurture sequences the moment they opt in.",
    bullets: [
      "20+ native email platform integrations",
      "Real-time subscriber sync with segment tagging",
      "One-click connection, no engineering required",
    ],
    imgSrc: integrations,
    alt: "DojoMojo integrations grid",
  },
];
